export default __webpack_public_path__ + "static/media/1983.71671722.png";